import uuid from "react-uuid";
import { apiClient } from "./axios";
import axios from "axios";

const signupHooks = async ({
  private_id,
  user_name,
  message_allow,
  gender,
  hp,
  private_consent,
  marketing_consent,
  birth,
}) => {
  try {
    let device_specific = window.localStorage.getItem("device-unique-token");
    if (device_specific == null) {
      const newToken = uuid();
      window.localStorage.setItem("device-unique-token", newToken);
      device_specific = newToken;
    }

    const res = await apiClient.post("/api/v1/user/signup", {
      private_id,
      user_name,
      message_allow,
      gender,
      hp,
      private_consent,
      marketing_consent,
      birth,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    return { status: false, error: error.message };
  }
};

const signinHooks = async ({ private_id }) => {
  try {
    const res = await apiClient.post("/api/v1/user/signin", {
      private_id,
    });

    return res.data;
  } catch (error) {
    console.error(error);
    return { status: false, error: error.message };
  }
};

const sendSmsHooks = async ({ hp }) => {
  try {
    const res = await apiClient.post("/api/v1/user/send/sms/auth", {
      hp,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const verifySmsHooks = async ({ hp, code }) => {
  try {
    const res = await apiClient.post("/api/v1/user/sms/auth", {
      hp,
      code,
    });
    if (!res.data.status) {
      console.error(res.data.result);
      return { IsError: true, message: res.data.result };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const logoutHooks = async (accessToken) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/api/v1/user/logout`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: accessToken,
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("로그아웃 요청 실패 (무시하고 진행):", error);
    return { status: true };
  }
};

const reissueAccessTokenHooks = async (refreshToken) => {
  try {
    const res = await apiClient.get("/api/v1/user/issued/access", {
      headers: {
        Authorization: refreshToken,
      },
    });
    if (!res.data.status) {
      console.error(res.data);
      return { IsError: true };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const issueMultipleTokensHooks = async (refreshToken, deviceToken) => {
  try {
    const res = await apiClient.post(
      "/api/v1/user/issued/multiple",
      {
        device_token: deviceToken,
      },
      {
        headers: {
          Authorization: refreshToken,
        },
      }
    );
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true, error: res.data.error };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const createBabyHooks = async ({ babyBirth, babyType, babyName }) => {
  try {
    const res = await apiClient.post("/api/v1/user/create/baby", {
      baby_birth: babyBirth,
      baby_type: babyType,
      baby_name: babyName,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const updateBabyHooks = async ({ id, babyBirth, babyType, babyName }) => {
  try {
    const res = await apiClient.post("/api/v1/user/update/baby", {
      id,
      baby_birth: babyBirth,
      baby_type: babyType,
      baby_name: babyName,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }

    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const changePhoneNumberHooks = async ({ hp }) => {
  try {
    const res = await apiClient.post("/api/v1/user/change/hp", {
      hp,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }
    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const updateMessageAllowHooks = async ({ messageAllow }) => {
  try {
    const res = await apiClient.post("/api/v1/user/message", {
      message_allow: messageAllow,
    });
    if (!res.data.status) {
      console.error(res.data.error);
      return { IsError: true };
    }

    return res.data;
  } catch (error) {
    console.error(error);
    return { IsError: true };
  }
};

const userHooks = {
  signupHooks,
  signinHooks,
  sendSmsHooks,
  verifySmsHooks,
  logoutHooks,
  reissueAccessTokenHooks,
  issueMultipleTokensHooks,
  createBabyHooks,
  updateBabyHooks,
  changePhoneNumberHooks,
  updateMessageAllowHooks,
};

export default userHooks;
